import React from 'react';
import classnames from 'classnames';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
  VIDEO_PAUSED: { id: 'VideoState.VIDEO_PAUSED', defaultMessage: 'Video pausiert' },
  REMOTE_PAUSED: { id: 'VideoState.REMOTE_PAUSED', defaultMessage: 'Die Bildübertragung wurde durch Ihren Kunden angehalten. Es geht weiter, sobald er die Übertragung wieder startet.' },
  LOCAL_PAUSED_PREFIX: { id: 'VideoState.LOCAL_PAUSED_PREFIX', defaultMessage: 'Sie haben die Bildübertragung pausiert. Klicken Sie auf' },
  LOCAL_PAUSED_SUFFIX: { id: 'VideoState.LOCAL_PAUSED_SUFFIX', defaultMessage: 'in der Leiste, um sie fortzusetzen.' },
});

function VideoState({
    videoActive,
    videoPaused,
    isRemote,
    intl: { formatMessage }
}) {
  const active = videoActive;
  const paused = videoActive && videoPaused;
  
  if (!paused) {
    return null; // Do not show anything during initialization
  }

  const subtitle = isRemote 
    ? formatMessage(messages.REMOTE_PAUSED) 
    : (
      <span>
        {formatMessage(messages.LOCAL_PAUSED_PREFIX)} 
        <span style={{
          background: 'rgba(255,255,255,0.2)',
          padding: '2px 10px',
          borderRadius: '12px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          margin: '0 4px',
          fontWeight: '500'
        }}>
          <i className="fa fa-play-circle-o" /> Play
        </span> 
        {' '}{formatMessage(messages.LOCAL_PAUSED_SUFFIX)}
      </span>
    );

  return (
    <div className={classnames('video-state', { active, paused })} style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 10
    }}>
      <div className="video-state-pill">
        <div className="video-state-pill-header">
          <i className="fa fa-pause-circle-o" style={{ fontSize: '24px' }} />
          <span>{formatMessage(messages.VIDEO_PAUSED)}</span>
        </div>
        <span className="video-state-pill-subtitle">
          {subtitle}
        </span>
      </div>
    </div>
  );
}

export default injectIntl(VideoState);
